import { membershipStyles } from "../../themes/commonStyle";

export type HowTosSection = {
  title: string;
  description: string;
  image: string;
  comingSoon?: boolean;
};

export type HowTosSectionsGroup = {
  title: string;
  description: string;
  groupStyle: React.CSSProperties;
  sections: HowTosSection[];
};

const imageUrl = 'https://picsum.photos/id/27/1536/768.jpg';

export const howTosSectionsGroup: HowTosSectionsGroup[] = [
  {
    title: 'Free Membership',
    description: 'Access to basic features and functionalities.',
    groupStyle: membershipStyles.Free,
    sections: [{
      title: 'Median Sales Price',
      description: 'The median price of the homes in the selected area within the chosen period of time. Watch the video below for more information.',
      image: imageUrl,
    },
    {
      title: 'Median Rental Price',
      description: 'The median rental price per month of the homes in the selected area within the chosen time period. Watch the video below for more information.',
      image: imageUrl,
    },
    {
      title: 'Median Sales Price per Sq Ft',
      description: 'The median of sale price divided by square footage of the homes in the selected area within the chosen period of time. Watch the video below for more information.',
      image: imageUrl,
    },
    {
      title: 'Median Rental Price per Sq Ft',
      description: 'The median of rental price per month divided by square footage of the homes in the selected area within the chosen period of time. Watch the video below for more information.',
      image: imageUrl,
    },
    {
      title: 'Days on Sales Market',
      description: 'The calculated median of days on the market within the selected area and chosen time period. Watch the video below for more information.',
      image: imageUrl,
    },
    {
      title: 'Days on Rental Market',
      description: 'The calculated median of days on the rental market within the selected area and chosen time period. Watch the video below for more information.',
      image: imageUrl,
    },
    {
      title: 'Number of Sales',
      description: 'Number of home sales within the selected area and chosen time period. Watch the video below for more information.',
      image: imageUrl,
    },
    {
      title: 'Number of Rentals',
      description: 'Number of homes for rent within the selected area and chosen time period. Watch the video below for more information.',
      image: imageUrl,
    },

    ],
  },
  {
    title: 'Novice Membership',
    description: 'Enhanced features for novice users.',
    groupStyle: membershipStyles.Novice,
    sections: [
      {
        title: 'Sales Appreciation',
        description: 'The attribute is designed to estimate the appreciation in prices (positive and negative) within certain areas and preset time period. Watch the video below for more information.',
        image: imageUrl,
      },
      {
        title: 'Rental Appreciation',
        description: 'The attribute is designed to estimate the appreciation in prices (positive and negative) within certain areas and preset time period. Watch the video below for more information.',
        image: imageUrl,
      },
      {
        title: 'Sales Market Efficiency',
        description: 'This attribute takes the ratio of a median listing and median sold prices. The result is an indicator of a Seller\'s, Neutral or Buyer\'s market. Watch the video below for more information.',
        image: imageUrl,
      },
      {
        title: 'Rental Market Efficiency',
        description: 'This attribute takes the ratio of a median listing and median sold prices. The result is an indicator of a Seller\'s, Neutral or Buyer\'s market. Watch the video below for more information.',
        image: imageUrl,
      },
    ],
  },
  {
    title: 'Pro Membership',
    description: 'Advanced features for professional users.',
    groupStyle: membershipStyles.Pro,
    sections: [
      {
        title: 'Average Tax Rate',
        description: 'Property tax rate is the information collected from the tax authority websites and represents the most current values within the assessed areas. Average Tax Rate is calculated within the area of interest and most accurately represented at the Subdivision level. Watch the video below for more information.',
        image: imageUrl,
      },
      {
        title: 'Median HOA',
        description: 'HOA (home owners association) rate is the information collected from the real estate listing websites and represents the most current values within the assessed areas. Median HOA is calculated within the area of interest and most accurately represented at the Subdivision level. Watch the video below for more information.',
        image: imageUrl,
        comingSoon: true
      },
      {
        title: 'Cap Rate',
        description: 'Cap rate is an advanced attribute, which is calculated by dividing net yearly operational income by an estimated market value and often used to compare different investment opportunities. Watch the video below for more information.',
        image: imageUrl,
        comingSoon: true
      },
      {
        title: `Investor's Index`,
        description: `Investor's Index is an advanced attribute, which is derived through an empirical relationship and combines the potential income and demand for rentals in certain areas. This derivative is meant as a sole attribute for quick search and analysis of an investment. Watch the video below for more information.`,
        image: imageUrl,
        comingSoon: true
      },
      {
        title: 'Sales Price Prediction',
        description: 'This attribute uses Monte Carlo Simulation algorithm in an attempt to demonstrate how the prices may change with time. The further in the future the prognosis are built the less accuracy is expected. Several prebuilt market scenarios are available to choose from. Watch the video below for more information.',
        image: imageUrl,
        comingSoon: true
      },
      {
        title: 'Rental Price Prediction',
        description: 'This attribute uses Monte Carlo Simulation algorithm in an attempt to demonstrate how the prices may change with time. The further in the future the prognosis are built the less accuracy is expected. Several prebuilt market scenarios are available to choose from. Watch the video below for more information.',
        image: imageUrl,
        comingSoon: true
      },
    ],
  }
];